<template>
  <div class="register-page">
    <div class="register-form">
      <div class="form-logo">
        <img src="~assets/logo-login.png" alt="">
      </div>
      <div class="form-input">
        <i class="iconfont icon-dingdan"></i><input type="text" v-model="info.name" placeholder="请输入您的姓名">
      </div>
      <div class="form-input">
        <i class="iconfont icon-dingdan"></i><input type="text" v-model="info.phone" name="" placeholder="请输入您的电话">
      </div>
      <div class="form-input">
        <i class="iconfont icon-dingdan"></i><input type="text"  v-model="info.email" placeholder="请输入您的邮箱">
      </div>
      <div class="form-input">
        <i class="iconfont icon-dingdan"></i><input type="text"  v-model="info.unit" placeholder="所在单位/学校名">
      </div>
      <div class="form-input">
        <i class="iconfont icon-dingdan"></i><input type="text"  v-model="info.job" placeholder="职位">
      </div>
      <div class="form-input">
        <i class="iconfont icon-dingdan"></i><input type="password"  v-model="info.password" placeholder="请填写6-12位密码">
      </div>
      <div class="form-input">
        <i class="iconfont icon-dingdan"></i><input type="password"  v-model="info.rePassword" placeholder="请重新输入您的密码">
      </div>
      <div class="other-option">
        <div class="left-content">
        </div>
        <div class="right-content">
          <a href="javascript:;" @click="goLogin">登录</a><a>|</a><a href="javascript:;">注册</a>
        </div>
      </div>
      <a href="javascript:;" class="form-btn" @click="register">
        现在注册
      </a>
    </div>
  </div>
</template>

<script>
  import {
    axiosSysApi2
  } from '../axios_init'

  export default {
    data () {
      return {
        checked: false,
        info: {
          name: '',
          phone: '',
          email: '',
          unit: '',
          job: '',
          password: '',
          rePassword: ''
        }
      }
    },
    methods: {
      register () {
        let vm = this
        if (this.info.password === this.info.rePassword) {
          let data = {
            account: this.info.name,
            password: this.info.password,
            other_info: 'email=' + this.info.email + '&phone=' + this.info.phone + '&unit=' + this.info.unit + '&job=' + this.info.job
          }
          axiosSysApi2.post('/register', window.JSON.stringify(data)).then(function (response) {
            vm.$store.dispatch('showNoticeMsg', {
              type: 'info',
              title: '注册成功',
              message: '跳转登录！'
            })
            vm.$router.push('/login')
          }).catch(function (e) {
            vm.$store.dispatch('showNoticeMsg', {
              type: 'warning',
              title: '注册失败',
              message: e
            })
          })
        } else {
          console.log('密码不一致')
        }
      },
      goLogin () {
        this.$router.push('/login')
      }
    }
  }
</script>

<style scoped lang="less">
  @import '../style/base.less';
  .register-page {
    position: fixed;
    width: 100%;
    display: flex;
    justify-content: center;
    background:url('~assets/login-bak.png');
    background-repeat: no-repeat;
    background-size: 100%, auto;
    .register-form {
      width: 400px;
    }
  }
</style>



// WEBPACK FOOTER //
// register.vue?6dc7d640